module.exports = __webpack_public_path__ + "img/programmeBG.4df2fcfe.png";